import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SalaryscaleService {

  constructor(private http: HttpClient) { }

  getScaleData(limit) {
    return this.http.get<any>(`/salary_survey/api/salaryScale/scaleslist?limit=${limit}`)
      .pipe(map(data => {
        return data;
      }));
  }

  getlatestScaleData(limit) {
    return this.http.get<any>(`/salary_survey/api/salaryScale/latestscaleslist?limit=${limit}`)
      .pipe(map(data => {
        return data;
      }));
  }
}
